import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";

/**
 * 同时只执行一次函数，直到前一个promise返回
 * @param func
 * @returns {Function}
 */
export function executeOneInTime(func) {
  var isRunning = false;
  return function () {
    if (!isRunning) {
      isRunning = true;
      var res = func.apply(this, arguments);

      if (_typeof(res) === 'object' && typeof res.finally === 'function') {
        // res instanceof Promise 在Android上有问题
        res.finally(function () {
          isRunning = false;
        });
      } else {
        isRunning = false;
      }
    }
  };
}
/**
 * 模拟暂停
 * @param timeout sleep毫秒数
 */

export function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}